import { render, staticRenderFns } from "./DetailExceedTips.vue?vue&type=template&id=80db362c&scoped=true&"
import script from "./DetailExceedTips.vue?vue&type=script&lang=js&"
export * from "./DetailExceedTips.vue?vue&type=script&lang=js&"
import style0 from "./DetailExceedTips.vue?vue&type=style&index=0&id=80db362c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80db362c",
  null
  
)

export default component.exports